/**
 * DEX Scroll Animations + Subtle Parallax
 * Agent 8 — Shopify implementation
 *
 * Handles:
 * - [data-dex-animate] — fade-in on scroll
 * - [data-dex-stagger] — staggered children reveal
 * - .dex-hero__mesh — subtle parallax on scroll
 */
(function () {
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReduced) {
    document.querySelectorAll('[data-dex-animate], [data-dex-stagger]').forEach(function (el) {
      el.classList.add('dex-visible');
    });
    return;
  }

  /* ── IntersectionObserver for scroll reveals ── */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('dex-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -60px 0px' }
    );

    function observe() {
      document.querySelectorAll('[data-dex-animate], [data-dex-stagger]').forEach(function (el) {
        if (!el.classList.contains('dex-visible')) {
          observer.observe(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }

    document.addEventListener('shopify:section:load', observe);
  } else {
    document.querySelectorAll('[data-dex-animate], [data-dex-stagger]').forEach(function (el) {
      el.classList.add('dex-visible');
    });
  }

  /* ── Subtle parallax on hero mesh ── */
  var mesh = document.querySelector('.dex-hero__mesh');
  if (mesh) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrollY = window.pageYOffset;
          if (scrollY < 900) {
            mesh.style.transform = 'translate(' + (scrollY * 0.02) + 'px, ' + (scrollY * 0.06) + 'px)';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }
})();
